import { createPromiseClient } from '@bufbuild/connect';
import { LmsConnectedClassAPIServiceV2 } from '@protos/learning_management/lms.connected.apis_connect';

import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { ConnectTransportOptions } from '@bufbuild/connect-web';

const LmsConnectedClassAPIServiceV1Client = createPromiseClient(
  LmsConnectedClassAPIServiceV2,
  lmsTransport
);

export const useLmsConnectedClassAPIServiceV2ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsConnectedClassAPIServiceV2,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
